import React from "react";
import "./styles/taskcenter.css";
import giftBox from "../../assets/images/airdrop/giftbox.png";
import Exchange from "../../assets/images/airdrop/Exchange 15.png";
export default function TaskCenter() {
  return (
    <div className="taskCenter-container container-fluid pb-5 ">
      <div className="row py-5 d-flex justify-content-center align-items-center ">
        <div className="col-12 d-flex justify-content-center align-items-center ">
          <button className="airdrop-white me-5">Task Center</button>
          <button className="taskCenter-unlocking">Unlocking Rules</button>
        </div>
      </div>
      <div className="row py-2 d-flex justify-content-center align-items-center ">
        <div className="col-12 d-flex justify-content-center align-items-center">
          <img src={giftBox} alt="" className="me-3" />
          <span className="airdrop-para">Task Center</span>
        </div>
        <div className="col-12 d-flex justify-content-center align-items-center">
          <span className="receive-para">Receive more ET</span>
        </div>
      </div>
      <div className="row d-flex justify-content-center align-items-center px-3">
        <div className="col-12 col-md-6 col-lg-4 py-2">
          <div className="cardTask pb-3">
            <div className="card-body d-flex justify-content-center align-items-center flex-column">
              <h5 className="cardTitle my-3">Instant Sign Up for SuperEx</h5>
              <div className="d-flex justify-content-center align-items-center flex-row my-3">
                <img src={Exchange} className="img-fluid imgEx" alt="..." />
                <span className="et ">+5 ET</span>
              </div>
              <button className="taskCenter-unlocking">Signup</button>
            </div>
          </div>
        </div>
        <div className="col-12 col-md-6 col-lg-4 py-2">
          <div className="cardTask pb-3">
            <div className="card-body d-flex justify-content-center align-items-center flex-column">
              <h5 className="cardTitle my-3">Instant Sign Up for SuperEx</h5>
              <div className="d-flex justify-content-center align-items-center flex-row my-3">
                <img src={Exchange} className="img-fluid imgEx" alt="..." />
                <span className="et ">+5 ET</span>
              </div>
              <button className="taskCenter-unlocking">Signup</button>
            </div>
          </div>
        </div>
        <div className="col-12 col-md-6 col-lg-4 py-2">
          <div className="cardTask pb-3">
            <div className="card-body d-flex justify-content-center align-items-center flex-column">
              <h5 className="cardTitle my-3">Instant Sign Up for SuperEx</h5>
              <div className="d-flex justify-content-center align-items-center flex-row my-3">
                <img src={Exchange} className="img-fluid imgEx" alt="..." />
                <span className="et ">+5 ET</span>
              </div>
              <button className="taskCenter-unlocking">Signup</button>
            </div>
          </div>
        </div>
        <div className="col-12 col-md-6 col-lg-4 py-2">
          <div className="cardTask pb-3">
            <div className="card-body d-flex justify-content-center align-items-center flex-column">
              <h5 className="cardTitle my-3">Instant Sign Up for SuperEx</h5>
              <div className="d-flex justify-content-center align-items-center flex-row my-3">
                <img src={Exchange} className="img-fluid imgEx" alt="..." />
                <span className="et ">+5 ET</span>
              </div>
              <button className="taskCenter-unlocking">Signup</button>
            </div>
          </div>
        </div>
        <div className="col-12 col-md-6 col-lg-4 py-2">
          <div className="cardTask pb-3">
            <div className="card-body d-flex justify-content-center align-items-center flex-column">
              <h5 className="cardTitle my-3">Instant Sign Up for SuperEx</h5>
              <div className="d-flex justify-content-center align-items-center flex-row my-3">
                <img src={Exchange} className="img-fluid imgEx" alt="..." />
                <span className="et ">+5 ET</span>
              </div>
              <button className="taskCenter-unlocking">Signup</button>
            </div>
          </div>
        </div>
        <div className="col-12 col-md-6 col-lg-4 py-2">
          <div className="cardTask pb-3">
            <div className="card-body d-flex justify-content-center align-items-center flex-column">
              <h5 className="cardTitle my-3">Instant Sign Up for SuperEx</h5>
              <div className="d-flex justify-content-center align-items-center flex-row my-3">
                <img src={Exchange} className="img-fluid imgEx" alt="..." />
                <span className="et ">+5 ET</span>
              </div>
              <button className="taskCenter-unlocking">Signup</button>
            </div>
          </div>
        </div>
      </div>
      <div className="row d-flex justify-content-center align-items-center px-2 py-3">
        <div className="col-6 d-flex justify-content-center align-items-center ">
          <p className="task-para">
            *Complete all the above tasks to get whitelisted and SuperEx will
            randomly airdrop a large amount of ET tokens to whitelisted users
            from time to time.
          </p>
        </div>
      </div>
    </div>
  );
}
